import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const GitBranchIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.31209 12.1471C9.31209 13.0164 10.0168 13.7211 10.886 13.7211C11.7553 13.7211 12.46 13.0164 12.46 12.1471C12.46 11.2778 11.7553 10.5732 10.886 10.5732C10.0168 10.5732 9.31209 11.2778 9.31209 12.1471ZM9.31209 12.1471H8.00027C5.79121 12.1471 4.00038 10.3564 4.00027 8.14731L4 2.6665M9.01698 5.8513H4M12.46 5.8513C12.46 6.72057 11.7553 7.42525 10.886 7.42525C10.0168 7.42525 9.31209 6.72057 9.31209 5.8513C9.31209 4.98203 10.0168 4.27735 10.886 4.27735C11.7553 4.27735 12.46 4.98203 12.46 5.8513Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

GitBranchIcon.displayName = 'GitBranchIcon';
